// extracted by mini-css-extract-plugin
export default {"popup_wrap":"style_popup_wrap__CmwB+"};